module.exports = __webpack_public_path__ + "img/partner1.c675c41f.png";